/**
 * 投诉原因创建或编辑
 */
import React from 'react';
import {
    Modal,
    message,
    Form,
    Input,
    InputNumber,
    Row,
    Col,
    Radio,
} from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './CauseModal.module.scss';
import http from '@/assets/api/http';
// import model from '@/reducers/systemanage/parameter/model';
import { regYuanToFen, regFenToYuan } from '@/util/money';
import { FloatConversion } from '@/util/conversion';


const FormItem = Form.Item;//表单校验
const formItemLayout = {
    labelCol: {
        sm: { span: 7 },
    },
    wrapperCol: {
        sm: { span: 17 },
    },
};

class CauseModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            titleTag: this.props.title,
            visible: this.props.visible,
            confirmLoading: false,
        };
        this.floatConversion = new FloatConversion();
    }
    formRef = React.createRef();
    componentDidMount() {
    }

    componentWillUnmount() {
    }


    _handleOk = () => {
        this.handleSubmit();
    }

    _handleCancel = () => {
        this.setState({
            visible: false,
        });
        this.props.closeMode();
    }


    handleSubmit = e => {//表单校验
        if (e) e.preventDefault();
        this.formRef.current.validateFields().then(async (fieldsValue) => {

            const { reason, sortNo, penalty, shieldNum, lvNum, status } = fieldsValue;
            const { data } = this.props;
            let url = data ? '/?cmd=com.xqxc.api.pig.mis.biz.platform.ComplaintReasonsMisService.updateComplaintReasons': '/?cmd=com.xqxc.api.pig.mis.biz.platform.ComplaintReasonsMisService.addComplaintReasons';
            let submitData = {
                id: data ? data.id : undefined,
                reason,
                sortNo,
                penalty: regYuanToFen(penalty),
                shieldNum: Number(shieldNum),
                lvNum: Number(lvNum),
                status,
            };

            this.setState({ confirmLoading: true }, () => {
                http(url, submitData, 'POST').then(() => {
                    data ? message.success('更新成功') : message.success('新建成功');
                    this.setState({
                        confirmLoading: false,
                        visible: false,
                    });
                    this.props.closeMode(true);
                }).catch((e = {}) => {
                    message.error(e.message);
                    this.setState({
                        confirmLoading: false,
                    });
                });
            });
        });
    };

    render() {
        const { visible, confirmLoading, titleTag, } = this.state;
        const { data = {} } = this.props;
        const {
            reason,
            sortNo,
            penalty,
            shieldNum,
            lvNum,
            status,
            id
        } = data;

        return (
            <Modal
                width={470}
                centered
                title={titleTag}
                visible={visible}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <Form {...formItemLayout} onFinish={this.handleSubmit} autoComplete='off' className="create-form" ref={this.formRef}
                        initialValues={{
                            reason,
                            sortNo,
                            penalty: data ? Number(regFenToYuan(penalty)) : 0,
                            shieldNum: shieldNum || 0,
                            lvNum: lvNum || 0,
                            status,
                        }}
                    >
                        <FormItem
                            name='reason'
                            label='投诉原因'
                            rules={[{ required: true, message: '请输入投诉原因', whitespace: true }, { max: 24, message: '24字除表情符号未任意字符', whitespace: true }]}
                        >
                            <Input placeholder='请输入' disabled={id == 1}/>
                        </FormItem>
                        <FormItem
                            name='sortNo'
                            label='类型排序'
                            rules={[{ required: true, message: '请输入类型排序' }, { type: 'number', min: 1, max: 99, message: '最小值1，最大值99' }]}

                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                min={1}
                                max={99}
                                precision={0}
                                disabled={id == 1}
                                placeholder='请输入'
                            />
                        </FormItem>
                        <div className={styles.explains}>
                            <FormItem
                                name='penalty'
                                label={<span className={styles.curt}>罚款金额 &nbsp;&nbsp;减扣</span>}
                                rules={[{ type: 'number', min: 0, max: 999.99, message: '最小值0，最大值999.99' }]}
                            >

                                <InputNumber
                                    style={{ width: '100%'}}
                                    min={0}
                                    max={999.99}
                                    precision={2}
                                    placeholder='请输入'
                                />


                            </FormItem>
                            <FormItem
                                name='shieldNum'
                                label={<span className={styles.curt}>拉黑天数 &nbsp;&nbsp;减扣</span>}
                                rules={[
                                { type: 'number', min: 0, max: 999, message: '最小值0，最大值999' },]}
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={0}
                                    max={999}
                                    precision={0}
                                    placeholder='请输入'
                                />
                            </FormItem>
                            <FormItem
                                name='lvNum'
                                label={<span className={styles.curt}>等级分值 &nbsp;&nbsp;减扣</span>}
                                rules={[
                                { type: 'number', min: 0, max: 999, message: '最小值0，最大值999' },]}
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={0}
                                    max={999}
                                    precision={0}
                                    placeholder='请输入'
                                />
                            </FormItem>
                        </div>
                        <FormItem
                            name='status'
                            label='状态'
                            rules={[{ required: true, message: '请选择状态' }]}
                        >
                            <Radio.Group disabled={id == 1}>
                                <Radio value={1}>启用</Radio>
                                <Radio value={0}>禁用</Radio>
                            </Radio.Group>
                        </FormItem>
                    </Form>
                </div>
            </Modal>
        );

    }
}

CauseModal.propTypes = {
    data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
};

const mapStateToProps = (state) => {
    return {
        // details: state.parameter.complaintDetails,
    };
};

export default connect(mapStateToProps)(CauseModal);